module.exports = __webpack_public_path__ + "media/images/farey/farey_services_logo_vente_cabinets_medicaux-0c989fcfd8250d69d2ae898a773787c5.png";